// Custom video controls
export function video() {
  if (document.querySelector(".m-video")) {
    var video = document.querySelector(".m-video video");
    var button = document.querySelector(".m-video .button");

    button.addEventListener("click", function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener("play", function () {
      button.classList.remove("play");
      button.classList.add("paused");
    });

    video.addEventListener("pause", function () {
      button.classList.remove("paused");
      button.classList.add("play");
    });
  }
}
